export namespace ProductTransactionTranslations {
  export const common = {
    productTransaction: 'productTransaction',
    containerTransaction: 'containerTransaction',
  } as const;

  export const error = {
    productTransactionsUnableToLoadError: 'productTransactionsUnableToLoadError',
    productTransactionExportConfigurationsUnableToLoadError: 'productTransactionExportConfigurationsUnableToLoadError',
  } as const;

  export const exportConfigurations = {
    productTransactionExportConfigurationDeleteConfirmationText:
      'productTransactionExportConfigurationDeleteConfirmationText',
  } as const;
}
